<template>
	<Dialog
		max-width="600"
		content-height="50"
		title="Add a new report"
		:show="show"
		@close="close"
	>
		<template slot="content">
			<v-autocomplete
				v-model="report.projectId"
				:error-messages="report.errors.projectId"
				:disabled="report.saving"
				:items="projects.models"
				no-data-text="No projects found. Please create a new project"
				label="Project"
				item-text="name"
				item-value="id"
			/>
			<v-text-field
				v-model="report.name"
				:error-messages="report.errors.name"
				:disabled="report.saving"
				name="Name"
				label="Report Name"
			/>
			<v-menu
				v-model="dateMenu"
				:close-on-content-click="false"
				lazy
				transition="scale-transition"
				offset-y
				full-width
				max-width="290px"
				min-width="290px"
			>
				<template slot="activator" slot-scope="{ on }">
					<v-text-field
						v-model="report.date"
						:error-messages="report.errors.date"
						label="Date"
						readonly
						v-on="on"
					/>
				</template>
				<v-date-picker
					v-model="report.date"
					:max="maxDateAllowed"
					min="1971-01-01"
					show-current
					no-title
					@input="dateMenu = false"
				/>
			</v-menu>
		</template>
		<template slot="buttons">
			<v-btn
				flat
				color="success"
				:disabled="disabledButtons"
				:loading="report.saving"
				@click="create()"
			>
				Create
			</v-btn>
			<v-btn
				flat
				color="success"
				:disabled="disabledButtons"
				:loading="report.saving"
				@click="create(true)"
			>
				Create and Open
			</v-btn>
		</template>
	</Dialog>
</template>

<script>
import moment from 'moment';
import Dialog from '@/components/Global/Dialog';
import { Report } from '@/models/Report';

export default {
	components: {
		Dialog,
	},
	data() {
		return {
			show: false,
			dateMenu: false,
			report: new Report(),
		}
	},
	computed: {
		projects() {
			return this.$store.get('projects/active');
		},
		disabledButtons() {
			// Disable buttons on init with hasChanged
			const hasChanged = !!this.report.changed(); // .changed() returns false or array of changed attributes
			return !hasChanged || this.report.hasErrors() || this.report.saving;
		},
		maxDateAllowed() {
			return moment().add(15, 'days').format();
		},
	},
	methods: {
		create(redirect = false) {
			this.report.save().then(() => {
				const report = this.report.clone();
				
				// If in selected project, add to reports list
				const currentProject = this.$store.get('projects/currentProject');
				if (report.projectId === currentProject.id) {
					this.$store.get('reports/active').add(report);
				}
				
				this.$notify('success', `Report "${report.displayName}" created successfully.`);
				this.close();
				
				if (redirect) {
					this.$router.push({ name: 'ArticlesList', params: { reportId: report.id } });
				}
			}).catch((e) => {
				dump('Error creating report', e);
				// Temporary fix until back-end returns correct validation error object
				this.report.saving = false;
				if (e.response.response.status === 422) {
					this.$notify('error', 'The combination of name, date and project has already been taken.');
					return;
				}
				this.$notify('error', 'Failed to create a new report.');
			});
		},
		close() {
			this.show = false;
			this.report.clear();
		},
	},
}
</script>
